module.exports = __webpack_public_path__ + "static/img/case_6.ce1d96a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_6.jpg
// module id = jR+n
// module chunks = 0